<template>
<div>
  <van-row class="user-basic">
    <van-col span="8">&nbsp;</van-col>

    <van-col span="8">
      <img :src="headurl" class="user-head" @click="to('/level')"/>
      <van-tag round type="danger" size="large">{{level}}</van-tag>
      <p>{{nickname}}</p>
    </van-col>

    <van-col span="8">&nbsp;</van-col>
  </van-row>

  <van-cell title="本月预估收入" :label="income" class="month_income">
  </van-cell>

  <van-row class="user-links" to="wallet">
    <van-col span="6" class="user-wallet">
      <van-icon name="pending-payment" @click="to('/wallet')"/>
      提现
    </van-col>
    <van-col span="6" class="user-team">
      <van-icon name="contact" @click="to('/team')" />
      好友
    </van-col>
    <van-col span="6" class="user-orders">
      <van-icon name="pending-orders" @click="to('/orders')" />
      订单
    </van-col>
    <van-col span="6" class="user-share">
      <van-icon name="completed" @click="to('/task')"/>
      任务
    </van-col>
  </van-row>

  <van-cell-group class="user-group">
    <van-cell icon="share" title="我要安利给好友~" :value="next_lv_remain" is-link @click="toqr" />
    <!--<van-cell icon="question" title="推广&等级权益说明" value="" is-link @click="to('/level')" />
    <van-cell icon="share" title="不好用/有问题！找客服吐槽~" is-link @click="toqr" />-->
  </van-cell-group>

  <!--<van-cell-group>
    <van-cell icon="exchange" title="我的积分" is-link />
    <van-cell icon="gold-coin" title="我的优惠券" is-link />
    <van-cell icon="gift" title="我收到的礼物" is-link />
  </van-cell-group>-->
</div>
</template>

<script>
import { Tag, Row, Col, Icon, Cell, CellGroup } from "vant";

export default {
  components: {
    [Tag.name]: Tag,
    [Row.name]: Row,
    [Col.name]: Col,
    [Icon.name]: Icon,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup
  },
  data() {
    return { headurl: "", nickname: "", qrurl: "#", income: "", level: "", next_lv_remain:"" };
  },
  methods: {
    load(openid) {
      this.$http
        .get("https://cb.xhare.cn/info", {
          params: { openid: openid }
        })
        .then(
          function(res) {
            if (res.data.code == 0) {
              this.headurl = res.data.data.portrait;
              this.income = res.data.data.income;
              this.nickname = res.data.data.nickname;
              this.qrurl = "https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx1939c838a577589a&redirect_uri=https://m.xhare.cn/i/%23share%3Fu=" + res.data.data.uid + "&response_type=code&scope=snsapi_base&state=share";
              this.level = "LV" + res.data.data.level;
              if (res.data.data.next_lv_remain) {
                this.next_lv_remain = "(还差" + res.data.data.next_lv_remain + "个权益升级)"
              }
            }
          }.bind(this)
        )
        .catch(
          function() {
            this.redirect();
          }.bind(this)
        );
    },
    redirect() {
      window.location.href =
        "https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx1939c838a577589a&redirect_uri=https://m.xhare.cn/i/&response_type=code&scope=snsapi_base&state=ucenter";
    },
    toqr() {
      window.location.href = this.qrurl;
    },
    to(path) {
      this.$router.push({ path: path });
    }
  },
  mounted() {
    let openid = sessionStorage.getItem("openid");
    if (openid) {
      this.load(openid);
    } else {
      this.$http
        .get("https://cb.xhare.cn/openid", {
          params: { code: (window.location.search.substr(1).match(/(^|&)code=([^&]*)(&|$)/i)||[])[2] }
        })
        .then(
          function(res) {
            if (res.data.openid == "") {
              this.redirect();
            } else {
              this.load(res.data.openid);
              sessionStorage.setItem("openid", res.data.openid);
            }
          }.bind(this)
        )
        .catch(
          function() {
            this.redirect();
          }.bind(this)
        );
    }
  }
};
</script>

<style lang="less">
.month_income {
  .van-cell__label {
    font-size: 36px;
  }
}
.van-tag--round {
  position: absolute;
  transform: translate(-60%, -20%);
}
.user {
  &-basic {
    margin-top: 2rem;
  }
  &-group {
    margin-top: 2rem;
  }
  &-head {
    height: 4rem;
    width: 4rem;
    box-shadow: #aaa 1px 1px 3px 0px;
    border: 1px solid #aaa;
    border-radius: 150px;
    padding: 2px;
  }
  &-links {
    padding: 15px 0;
    font-size: 12px;
    text-align: center;
    background-color: #fff;
    .van-icon {
      display: block;
      font-size: 36px;
      padding: 5px;
    }
  }
  &-wallet {
    color: rgb(255, 177, 0);
  }
  &-team {
    color: rgb(255, 64, 129);
  }
  &-orders {
    color: rgb(37, 155, 36);
  }
  &-share {
    color: rgb(0, 128, 255);
  }
}
</style>
